import React from "react";
import "./Columns.css";

export default function FullScreenColumns({ data }) {
  return (
    <>
      <div
        className="container"
        style={{
          height: "90%",
          width: "calc(100% - 90px)",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          justifySelf: "center",
          alignSelf: "center",
          marginLeft: "72px",
        }}
      >
        <h1
          style={{
            fontSize: "2.179rem",
            color: "white",
            textAlign: "center",
            marginBottom: "60px",
            fontFamily: "LG_Smart_Bold",
            zIndex: "40",
          }}
        >
          {data.upper_text}
        </h1>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {data &&
            data.content.map((obj, i) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    margin: "0 2%",
                  }}
                >
                  <div
                    style={{
                      height: "65›0px",
                      width: "450px",
                      margin: "0 2% 0 2%",
                      zIndex: "3",
                      border: "3px solid #c20839",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        top: "0",
                        left: "0",
                        height: "90px",
                        width: "100%",
                        display: "flex",
                        marginTop: "20px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        alt=""
                        src={obj.title.first_letter_src}
                        style={{
                          margin: obj.title.first_letter_margin,
                          height: obj.title.first_letter_height,
                        }}
                      />

                      <h3
                        style={{
                          textAlign: "center",
                          marginBottom: "6px",
                          marginLeft: "4px",
                          color: "#c20839",
                          fontFamily: "LG_Smart_Bold",
                        }}
                      >
                        {obj.title.title}
                      </h3>
                    </div>
                    <div>
                      <div
                        style={{
                          margin: "0 10%",
                          height: "70px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            margin: "10px 0 10px 0",
                            fontSize: "1.719rem",
                            textAlign: "center",
                            color: "#fff",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: obj.top_body.text,
                          }}
                        ></p>
                      </div>
                      <hr
                        style={{
                          borderColor: "#c20839",
                          backgroundColor: "#c20839",
                          width: "75%",
                          height: "1px",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          color: "#fff",
                          fontFamily: "LG_Smart_Bold",
                          fontSize: "1.719rem",
                          height: "410px",
                          marginTop: "30px",
                        }}
                      >
                        {obj.bottom_body.text.map((text, i) => {
                          return <p style={{ margin: "16px 0" }}>{text}</p>;
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
}
